<template>
    <v-card>
        <v-card-title>
            {{  $t('skyroom_setting')  }} {{ company.title}}
        </v-card-title>
        <v-card-text>
            <v-form ref="serverForm">
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="domain" label="api_key" class="left-input mt-3" ></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="green darken-2" @click="saveSetting">
                {{  $t('save')  }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="red darken-2" @click="removeAskDialog=true" v-show="false">
                {{  $t('remove')  }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="close">
                {{  $t('close')  }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import axios from 'axios'
export default {
    name: 'SkyroomSetting',
    props: ['company'],
    data() {
        return {
            domain:"",
            saveLoading: false,
            deleteLoading: false,
            removeAskDialog:false,
        }
    },
    watch:{
        company:{
            handler(){
                this.getSkyroomSetting();
            },
            deep:true
        }
    },
    methods: {

        getSkyroomSetting() {
            axios({
                url: process.env.VUE_APP_BACKEND_URL+"/api/webinar_plus/skyroom_setting/"+this.company.id,
                method: "GET",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                this.domain = response.data.domain;
            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("no_skyroom_setting"));
            });
        },
        saveSetting() {
            let payload={company_id:this.company.id,domain:this.domain};
            axios({
                url: process.env.VUE_APP_BACKEND_URL+"/api/webinar_plus/skyroom_setting/"+this.company.id,
                method: "PUT",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
                data: payload,
            }).then(() => {
                this.$toasted.success(this.$t("skyroom_setting_save_successfully"));
                this.close()

            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("skyroom_setting_saving_error"));
            });
        }, 
        
   
        close() {
            this.$emit('close');
        }
    },
    mounted() {
        this.getSkyroomSetting();
    },



}
</script>
<style >
.left-input input{
    text-align: left;
    direction: ltr;
}
</style>